'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageChannelsByCategories
 * @description manages the list of available channels, grouped by categories
 */

angular.module('v-tv-package-services').service('TvPackageChannelsByCategories', function TvPackageChannelsByCategories(TvPackageApi, TvPackageChannelsHelperService, $cacheFactory, $q, tvPackageConfig) {

    var channelsCache = new $cacheFactory('ChannelsByCategories');

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageChannelsByCategories#getChannelsByCategories
     * @param {bool} [limitToBundledChannels=false] Use to display a package with only channel in a tab
     * @methodOf vTvPackageServices.TvPackageChannelsByCategories
     * @returns {Promise} a Promise that resolves with the categories of channels and their multiplexes/channels
     */
    this.getChannelsByCategories = function (limitToBundledChannels) {
        var channelsList = channelsCache.get('channelsList');
        var params = limitToBundledChannels ? { bundledChannels: true } : null;

        if (channelsList) {
            return $q.when(channelsList);
        }

        return TvPackageApi.doGet(tvPackageConfig.ENDPOINT.CHANNELS_BY_CATEGORIES, params).then(function (response) {

            TvPackageChannelsHelperService.initChannelsCategories(response.data.categories);
            TvPackageChannelsHelperService.indexChannelsCategoriesCharacteristics(response.data.categories);

            channelsCache.put('channelsList', response.data.categories);

            return response.data.categories;
        });
    };
});